import React from 'react';
import ImageUploader from './ImageUploader';
import './style.css';

const MainImageUploader = ({ disabledAdd, storageFolder, fileList, setFileList }) => {
  return (
    <div className='main-image'>
      <ImageUploader
        disabledAdd={disabledAdd}
        maxImageSize={1}
        storageFolder={storageFolder}
        fileList={fileList}
        setFileList={setFileList}
        multiple={false}
        thumbMaxDimension={600}
      />
    </div>
  );
};

export default MainImageUploader;
